<template lang="pug">
  dv-input(
    label="Доступные способы ответа"
    description="Выберите, как участник сможет ответить на вопрос. Можно выбрать несколько вариантов"
    v-bind="$attrs"
  )
    v-row
      v-col(
        v-for="(item, idx) in items"
        :key="idx"
        cols="12"
      )
        dv-checkbox(
          v-model="inputValue[item.key]"
          v-bind="item"
          :true-value="true"
          :false-value="false"
        )
</template>

<script>
import DvInput from '@/packages/ui/components/inputs/DvInput.vue';
import DvCheckbox from '@/packages/ui/components/inputs/DvCheckbox.vue';

export default {
  components: {
    DvInput,
    DvCheckbox,
  },
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      inputValue: this.value,
      items: [
        {
          label: 'Документ',
          description: 'Формат pdf, doc, docx, excel, powerpoint размером до 5 мб. Не более 10 документов',
          key: 'is_document_required',
        },
        {
          label: 'Изображение',
          description: 'Формат png, jpeg, jpg размером до 5 мб каждый. Не более 10 изображений',
          key: 'is_image_required',
        },
        {
          label: 'Ссылка',
          description: 'Прикрепление ссылки на внешние ресурсы. Не более 10 ссылок',
          key: 'is_link_required',
        },
        {
          label: 'Текст',
          description: 'Допускается вставка текста до 2000 символов',
          key: 'is_text_required',
        },
      ],
    };
  },
  watch: {
    value(val) {
      this.inputValue = val;
    },
    inputValue(val) {
      this.$emit('input', val);
    },
  },
};
</script>
